module.exports = __webpack_public_path__ + "static/img/reject.0c410286.svg";